import { Slider as SliderDS } from '@lmn/design-system';
import React from 'react';
import styled from 'styled-components';

export type RangeSelectedValues = {
  min: number;
  minAllowed: number;
  max: number;
  maxAllowed: number;
  disabled: boolean;
};

const SliderContainer = styled.div`
  width: 100%;
  border-radius: 8px;
  background-color: white;
`;

type SliderProps = {
  value: RangeSelectedValues;
  label?: string;
  disabled: boolean;
  handleChange: (value: number[] | number) => void;
  handleCommittedChange: (value: number[] | number) => void;
  formatter: (v: number) => string;
  hideMin: boolean;
  // Left out, the design system steps by 1, which makes a wide range unusable from the keyboard.
  step?: number;
};

const Slider = ({
  value,
  label,
  disabled,
  handleChange,
  handleCommittedChange,
  formatter,
  hideMin,
  step,
}: SliderProps) => {
  const { min, max, minAllowed, maxAllowed } = value;
  return (
    <SliderContainer className="slider" data-swipe-dismiss-ignore={true}>
      <SliderDS
        formatter={formatter}
        rangeMax={maxAllowed}
        rangeMin={minAllowed}
        selectedValue={hideMin ? max : min}
        LabelText={label || ''}
        disabled={disabled}
        handleChange={handleChange}
        handleCommittedChange={handleCommittedChange}
        selectedSecondValue={hideMin ? undefined : max}
        step={step}
      />
    </SliderContainer>
  );
};

export default Slider;
